import { Injectable, inject } from '@angular/core';
import * as ExcelJS from 'exceljs';
import { SysUtilService } from './sysUtil.service';
import { env } from '../../../app.constant';


// @Injectable()
export class SABAUDBReportUtilSBService {

    private sysUtil: SysUtilService = inject(SysUtilService);

    private initialPosition = 12;

    // private numberFormat = "#,##0.00";
    private numberFormat = "#,##0.00_);[Red](#,##0.00)";

    private fontStyle = {
        header: { name: 'Times New Roman', size: 10, bold: true },
        content: { name: 'Times New Roman', size: 10 }
    };
    private columns = [
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
        'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T',
        'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD',
        'AE', 'AF', 'AG', 'AH', 'AI', 'AJ', 'AK', 'AL', 'AM', 'AN',
        'AO', 'AP', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AV', 'AW', 'AX',
        'AY', 'AZ', 'BA', 'BB', 'BC', 'BD', 'BE', 'BF', 'BG', 'BH',
        'BI', 'BJ', 'BK', 'BL', 'BM', 'BN', 'BO', 'BP', 'BQ', 'BR',
        'BS', 'BT', 'BU', 'BV', 'BW', 'BX', 'BY', 'BZ', 'CA', 'CB',
        'CC', 'CD', 'CE', 'CF', 'CG', 'CH', 'CI', 'CJ', 'CK', 'CL',
        'CM', 'CN', 'CO', 'CP', 'CQ', 'CR', 'CS', 'CT'
    ];
    private columnTitle = [

        'Savings from & Prior Years', 'Continuing Investment', 'Supplemental Budget', // Approved Budget
        'Savings from & Prior Years', 'Continuing Investment', 'Adjustment', // Adjustments
        'Savings from & Prior Years', 'Continuing Investment', 'Adjusted Supplemental Budget', // Adjusted Approved Budget

        '1st Quarter Ending March 31', '2nd Quarter Ending June 30', '3rd Quarter Ending Sept. 30', '4th Quarter Ending Dec. 31', 'Allotments Received',
        '1st Quarter Ending March 31', '2nd Quarter Ending June 30', '3rd Quarter Ending Sept. 30', '4th Quarter Ending Dec. 31', 'Allotments Received',
        '1st Quarter Ending March 31', '2nd Quarter Ending June 30', '3rd Quarter Ending Sept. 30', '4th Quarter Ending Dec. 31', 'Allotments Received',

        '1st Quarter Ending March 31', '2nd Quarter Ending June 30', '3rd Quarter Ending Sept. 30', '4th Quarter Ending Dec. 31', 'Adjustments (Reduction, Modification)',
        '1st Quarter Ending March 31', '2nd Quarter Ending June 30', '3rd Quarter Ending Sept. 30', '4th Quarter Ending Dec. 31', 'Adjustments (Reduction, Modification)',
        '1st Quarter Ending March 31', '2nd Quarter Ending June 30', '3rd Quarter Ending Sept. 30', '4th Quarter Ending Dec. 31', 'Adjustments (Reduction, Modification)',

        '1st Quarter Ending March 31', '2nd Quarter Ending June 30', '3rd Quarter Ending Sept. 30', '4th Quarter Ending Dec. 31', 'Adjusted Total Allotments',
        '1st Quarter Ending March 31', '2nd Quarter Ending June 30', '3rd Quarter Ending Sept. 30', '4th Quarter Ending Dec. 31', 'Adjusted Total Allotments',
        '1st Quarter Ending March 31', '2nd Quarter Ending June 30', '3rd Quarter Ending Sept. 30', '4th Quarter Ending Dec. 31', 'Adjusted Total Allotments',

        '1st Quarter Ending March 31', '2nd Quarter Ending June 30', '3rd Quarter Ending Sept. 30', '4th Quarter Ending Dec. 31', 'Adjusted Total Allotments',
        '1st Quarter Ending March 31', '2nd Quarter Ending June 30', '3rd Quarter Ending Sept. 30', '4th Quarter Ending Dec. 31', 'Adjusted Total Allotments',
        '1st Quarter Ending March 31', '2nd Quarter Ending June 30', '3rd Quarter Ending Sept. 30', '4th Quarter Ending Dec. 31', 'Adjusted Total Allotments',

        '1st Quarter Ending March 31', '2nd Quarter Ending June 30', '3rd Quarter Ending Sept. 30', '4th Quarter Ending Dec. 31', 'Total',
        '1st Quarter Ending March 31', '2nd Quarter Ending June 30', '3rd Quarter Ending Sept. 30', '4th Quarter Ending Dec. 31', 'Total',
        '1st Quarter Ending March 31', '2nd Quarter Ending June 30', '3rd Quarter Ending Sept. 30', '4th Quarter Ending Dec. 31', 'Total',

        'Savings from & Prior Years', 'Continuing Investment', 'Supplemental Budget',
        'Savings from & Prior Years', 'Continuing Investment', 'Supplemental Budget',
        'Savings from & Prior Years', 'Continuing Investment', 'Supplemental Budget',
        'Savings from & Prior Years', 'Continuing Investment', 'Supplemental Budget'
    ];
    private borderStyle: any = {
        thin: { style: 'thin' },
        full: {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        },
        topBottom: {
            top: { style: 'thin' },
            bottom: { style: 'thin' }
        },
        leftRight: {
            left: { style: 'thin' },
            right: { style: 'thin' }
        },
        topLeft: {
            top: { style: 'thin' },
            left: { style: 'thin' }
        },
        topRight: {
            top: { style: 'thin' },
            left: { style: 'thin' }
        },
        bottomLeft: {
            bottom: { style: 'thin' },
            left: { style: 'thin' }
        },
        bottomRight: {
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        }
    };

    private formula: any = {
        e: `IF(OR(NOT(C*=""),NOT(D*="")),IF(C*="",0,C*)+IF(D*="",0,D*),"")`,
        h: `IF(OR(NOT(F*=""),NOT(G*="")),IF(F*="",0,F*)+IF(G*="",0,G*),"")`,
        i: `IF(OR(NOT(C*=""),NOT(F*="")),IF(C*="",0,C*)+IF(F*="",0,F*),"")`,
        j: `IF(OR(NOT(D*=""),NOT(G*="")),IF(D*="",0,D*)+IF(G*="",0,G*),"")`,
        k: `IF(OR(NOT(I*=""),NOT(J*="")),IF(I*="",0,I*)+IF(J*="",0,J*),"")`,
        p: `IF(OR(NOT(L*=""),NOT(M*=""),NOT(N*=""),NOT(O*="")),IF(L*="",0,L*)+IF(M*="",0,M*)+IF(N*="",0,N*)+IF(O*="",0,O*),"")`,
        u: `IF(OR(NOT(Q*=""),NOT(R*=""),NOT(S*=""),NOT(T*="")),IF(Q*="",0,Q*)+IF(R*="",0,R*)+IF(S*="",0,S*)+IF(T*="",0,T*),"")`,
        v: `IF(OR(NOT(L*=""),NOT(Q*="")),IF(L*="",0,L*)+IF(Q*="",0,Q*),"")`,
        w: `IF(OR(NOT(M*=""),NOT(R*="")),IF(M*="",0,M*)+IF(R*="",0,R*),"")`,
        x: `IF(OR(NOT(N*=""),NOT(S*="")),IF(N*="",0,N*)+IF(S*="",0,S*),"")`,
        y: `IF(OR(NOT(O*=""),NOT(T*="")),IF(O*="",0,O*)+IF(T*="",0,T*),"")`,
        z: `IF(OR(NOT(V*=""),NOT(W*=""),NOT(X*=""),NOT(Y*="")),IF(V*="",0,V*)+IF(W*="",0,W*)+IF(X*="",0,X*)+IF(Y*="",0,Y*),"")`,
        ae: `IF(OR(NOT(AA*=""),NOT(AB*=""),NOT(AC*=""),NOT(AD*="")),IF(AA*="",0,AA*)+IF(AB*="",0,AB*)+IF(AC*="",0,AC*)+IF(AD*="",0,AD*),"")`,
        aj: `IF(OR(NOT(AF*=""),NOT(AG*=""),NOT(AH*=""),NOT(AI*="")),IF(AF*="",0,AF*)+IF(AG*="",0,AG*)+IF(AH*="",0,AH*)+IF(AI*="",0,AI*),"")`,
        ao: `IF(OR(NOT(AK*=""),NOT(AL*=""),NOT(AM*=""),NOT(AN*="")),IF(AK*="",0,AK*)+IF(AL*="",0,AL*)+IF(AM*="",0,AM*)+IF(AN*="",0,AN*),"")`,
        at: `IF(OR(NOT(AP*=""),NOT(AQ*=""),NOT(AR*=""),NOT(AS*="")),IF(AP*="",0,AP*)+IF(AQ*="",0,AQ*)+IF(AR*="",0,AR*)+IF(AS*="",0,AS*),"")`,
        ay: `IF(OR(NOT(AU*=""),NOT(AV*=""),NOT(AW*=""),NOT(AX*="")),IF(AU*="",0,AU*)+IF(AV*="",0,AV*)+IF(AW*="",0,AW*)+IF(AX*="",0,AX*),"")`,
        bd: `IF(OR(NOT(AZ*=""),NOT(BA*=""),NOT(BB*=""),NOT(BC*="")),IF(AZ*="",0,AZ*)+IF(BA*="",0,BA*)+IF(BB*="",0,BB*)+IF(BC*="",0,BC*),"")`,
        bi: `IF(OR(NOT(BE*=""),NOT(BF*=""),NOT(BG*=""),NOT(BH*="")),IF(BE*="",0,BE*)+IF(BF*="",0,BF*)+IF(BG*="",0,BG*)+IF(BH*="",0,BH*),"")`,
        bn: `IF(OR(NOT(BJ*=""),NOT(BK*=""),NOT(BL*=""),NOT(BM*="")),IF(BJ*="",0,BJ*)+IF(BK*="",0,BK*)+IF(BL*="",0,BL*)+IF(BM*="",0,BM*),"")`,
        bs: `IF(OR(NOT(BO*=""),NOT(BP*=""),NOT(BQ*=""),NOT(BR*="")),IF(BO*="",0,BO*)+IF(BP*="",0,BP*)+IF(BQ*="",0,BQ*)+IF(BR*="",0,BR*),"")`,
        bx: `IF(OR(NOT(BT*=""),NOT(BU*=""),NOT(BV*=""),NOT(BW*="")),IF(BT*="",0,BT*)+IF(BU*="",0,BU*)+IF(BV*="",0,BV*)+IF(BW*="",0,BW*),"")`,
        cc: `IF(OR(NOT(BY*=""),NOT(BZ*=""),NOT(CA*=""),NOT(CB*="")),IF(BY*="",0,BY*)+IF(BZ*="",0,BZ*)+IF(CA*="",0,CA*)+IF(CB*="",0,CB*),"")`,
        ch: `IF(OR(NOT(CD*=""),NOT(CE*=""),NOT(CF*=""),NOT(CG*="")),IF(CD*="",0,CD*)+IF(CE*="",0,CE*)+IF(CF*="",0,CF*)+IF(CG*="",0,CG*),"")`,
        ci: `IF(OR(NOT(AT*=""),NOT(BI*="")),IF(AT*="",0,AT*)-IF(BI*="",0,BI*),"")`,
        cj: `IF(OR(NOT(AY*=""),NOT(BN*="")),IF(AY*="",0,AY*)-IF(BN*="",0,BN*),"")`,
        ck: `IF(OR(NOT(CI*=""),NOT(CJ*="")),IF(CI*="",0,CI*)+IF(CJ*="",0,CJ*),"")`,
        cn: `IF(OR(NOT(CL*=""),NOT(CM*="")),IF(CL*="",0,CL*)+IF(CM*="",0,CM*),"")`,
        co: `IF(OR(NOT(BI*=""),NOT(BX*=""),NOT(CL*="")),IF(BI*="",0,BI*)-IF(BX*="",0,BX*)-IF(CL*="",0,CL*),"")`,
        cp: `IF(OR(NOT(BN*=""),NOT(CC*=""),NOT(CM*="")),IF(BN*="",0,BN*)-IF(CC*="",0,CC*)-IF(CM*="",0,CM*),"")`,
        cq: `IF(OR(NOT(CO*=""),NOT(CP*="")),IF(CO*="",0,CO*)+IF(CP*="",0,CP*),"")`,
        cr: `IF(OR(NOT(I*=""),NOT(P*="")),IF(I*="",0,I*)-IF(P*="",0,P*),"")`,
        cs: `IF(OR(NOT(J*=""),NOT(U*="")),IF(J*="",0,J*)-IF(U*="",0,U*),"")`,
        ct: `IF(OR(NOT(CL*=""),NOT(CM*="")),IF(CL*="",0,CL*)+IF(CM*="",0,CM*),"")`
    };

    async generateExcel(content: Array<any>, campus: number, year: number, options: any = { fileName: "SABAUDB", sheetName: "Sheet1" }) {

        this.columnTitle[0] = `Savings from ${year - 1} & Prior Years`;

        let data = [];

        content.forEach((d: any) => {
            let dt = JSON.parse(JSON.stringify(d));
            dt.fnd_name = d.fnd_name.replaceAll(/(<([^>]+)>)|(\&nbsp;)/ig, '');
            data.push(dt);
        });

        const wb = new ExcelJS.Workbook();
        const ws = wb.addWorksheet(options.sheetName);
        // const ws = wb.getWorksheet(options.sheetName);

        const imagePath = './assets/BatStateULogo.png';

        this.sysUtil.getBase64ImageFromUrl(imagePath).then(async (result: any) => {
            let imageId = wb.addImage({
                base64: result,
                extension: 'png'
            });
            ws.addImage(imageId, {
                tl: { col: 7, row: 0 },
                ext: { width: 120, height: 110 }
            });

            ws.columns = [
                { header: "", key: "fnd_name", width: 46 },
                { header: "", key: "acct_uacs_code", width: 15 },
                { header: "", key: "appr_amount_sb", width: 16 },
                { header: "", key: "appr_amount_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "adjustment_amount_sb", width: 16 },
                { header: "", key: "adjustment_amount_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "adjusted_amount_sb", width: 16 },
                { header: "", key: "adjusted_amount_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "q1_sb", width: 16 },
                { header: "", key: "q2_sb", width: 16 },
                { header: "", key: "q3_sb", width: 16 },
                { header: "", key: "q4_sb", width: 16 },
                { header: "", key: "total_allotment_sb", width: 16 },
                { header: "", key: "q1_cb", width: 16 },
                { header: "", key: "q2_cb", width: 16 },
                { header: "", key: "q3_cb", width: 16 },
                { header: "", key: "q4_cb", width: 16 },
                { header: "", key: "total_allotment_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "re_q1_sb", width: 16 },
                { header: "", key: "re_q2_sb", width: 16 },
                { header: "", key: "re_q3_sb", width: 16 },
                { header: "", key: "re_q4_sb", width: 16 },
                { header: "", key: "re_total_sb", width: 16 },
                { header: "", key: "re_q1_cb", width: 16 },
                { header: "", key: "re_q2_cb", width: 16 },
                { header: "", key: "re_q3_cb", width: 16 },
                { header: "", key: "re_q4_cb", width: 16 },
                { header: "", key: "re_total_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "adj_q1_sb", width: 16 },
                { header: "", key: "adj_q2_sb", width: 16 },
                { header: "", key: "adj_q3_sb", width: 16 },
                { header: "", key: "adj_q4_sb", width: 16 },
                { header: "", key: "total_adj_sb", width: 16 },
                { header: "", key: "adj_q1_cb", width: 16 },
                { header: "", key: "adj_q2_cb", width: 16 },
                { header: "", key: "adj_q3_cb", width: 16 },
                { header: "", key: "adj_q4_cb", width: 16 },
                { header: "", key: "total_adj_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "ors_q1_sb", width: 16 },
                { header: "", key: "ors_q2_sb", width: 16 },
                { header: "", key: "ors_q3_sb", width: 16 },
                { header: "", key: "ors_q4_sb", width: 16 },
                { header: "", key: "ors_total_sb", width: 16 },
                { header: "", key: "ors_q1_cb", width: 16 },
                { header: "", key: "ors_q2_cb", width: 16 },
                { header: "", key: "ors_q3_cb", width: 16 },
                { header: "", key: "ors_q4_cb", width: 16 },
                { header: "", key: "ors_total_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "dis_q1_sb", width: 16 },
                { header: "", key: "dis_q2_sb", width: 16 },
                { header: "", key: "dis_q3_sb", width: 16 },
                { header: "", key: "dis_q4_sb", width: 16 },
                { header: "", key: "dis_total_sb", width: 16 },
                { header: "", key: "dis_q1_cb", width: 16 },
                { header: "", key: "dis_q2_cb", width: 16 },
                { header: "", key: "dis_q3_cb", width: 16 },
                { header: "", key: "dis_q4_cb", width: 16 },
                { header: "", key: "dis_total_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "ors_unobligated_allotment_sb", width: 16 },
                { header: "", key: "ors_unobligated_allotment_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "due_demandable_sb", width: 16 },
                { header: "", key: "due_demandable_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "not_yet_due_sb", width: 16 },
                { header: "", key: "not_yet_due_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "unreleased_appr_amount_sb", width: 16 },
                { header: "", key: "unreleased_appr_amount_cb", width: 16 },
                { header: "", key: "", width: 16 },
            ];

            console.log(`total_content`, data);

            this.setHeader(ws, Number(campus), Number(year));

            let position = this.initialPosition + 6;
            data.forEach((data: any, i: number) => {

                data.due_demandable = (Number(data.due_demandable) == 0) ? "" : Number(data.due_demandable);
                data.not_yet_due = (Number(data.not_yet_due) == 0) ? "" : Number(data.not_yet_due);

                const exempted = ['fnd_name', 'acct_uacs_code', 'due_demandable', 'not_yet_due'];
                Object.keys(data).forEach((key: string) => {
                    if (!exempted.includes(key)) {
                        data[key] = (Number(data[key]) == 0) ? "" : Number(data[key]);
                    }
                });

                ws.addRow(data);

                this.columns.forEach((col: string, index: number) => {
                    let cell = ws.getCell(`${col}${position + i}`);
                    if (index >= 2) {
                        // cell.getCell(`J${currentRow}`).value = { formula: `sum(J${rowPosition}:J${currentRow - 1})+sum(${this.particularsTotalAmountValue.join(",")})`, date1904: false };
                        if (Object.keys(this.formula).includes(col.toLowerCase())) {
                            cell.value = { formula: `${this.formula[col.toLowerCase()].replaceAll('*', (position + i))}`, date1904: false };
                        }
                        cell.style = { numFmt: this.numberFormat };
                    }
                    cell.font = (data.aa_fnd_sysref_code == '') ? this.fontStyle.header : this.fontStyle.content;
                    cell.border = this.borderStyle.full;
                    cell.alignment = { wrapText: true, vertical: 'middle', horizontal: (col == 'A') ? 'left' : 'right' };
                });
            });

            const arrayData = await wb.xlsx.writeBuffer();
            const blob = new Blob([arrayData], { type: "application/octet-binary" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${options.fileName}.xlsx`;
            a.click();
            a.remove();
        });
    }

    private setHeader(ws: ExcelJS.Worksheet, campus: number, year: number) {
        let position = this.initialPosition + 1;

        // header title
        ws.mergeCells(`A1:AA1`);
        let row1 = ws.getCell(`A1`);
        row1.value = "Republic of the Philippines";
        row1.font = this.fontStyle.content;
        row1.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A2:AA2`);
        let row2 = ws.getCell(`A2`);
        row2.value = "BATANGAS STATE UNIVERSITY";
        row2.font = this.fontStyle.header;
        row2.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A3:AA3`);
        let row3 = ws.getCell(`A3`);
        row3.value = "The National Engineering University";
        row3.font = this.fontStyle.header;
        row3.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        let campusData = env.campuses.find((c: any) => c.value == campus);
        ws.mergeCells(`A4:AA4`);
        let row4 = ws.getCell(`A4`);
        row4.value = `${campusData.details.name}`;
        row4.font = this.fontStyle.header;
        row4.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A5:AA5`);
        let row5 = ws.getCell(`A5`);
        row5.value = `${campusData.details.addr}`;
        row5.font = this.fontStyle.content;
        row5.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A6:AA6`);
        let row6 = ws.getCell(`A6`);
        row6.value = `Tel Nos.: ${campusData.details.contact}`;
        row6.font = this.fontStyle.content;
        row6.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A7:AA7`);
        let row7 = ws.getCell(`A7`);
        row7.value = `E-mail Address: ${campusData.details.email} | Website Address: https://batstate-u.edu.ph`;
        row7.font = this.fontStyle.content;
        row7.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A9:AA9`);
        let row9 = ws.getCell(`A9`);
        row9.value = "Summary of Approved Budget, Allotment, Utilizations & Balances (SABAUD)";
        row9.font = this.fontStyle.header;
        row9.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A10:AA10`);
        let row10 = ws.getCell(`A10`);
        row10.value = `Supplemental Budget FY ${year}`;
        row10.font = this.fontStyle.header;
        row10.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A11:AA11`);
        let row11 = ws.getCell(`A11`);
        row11.value = `as of ${year}`;
        row11.font = this.fontStyle.header;
        row11.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        // header body
        let ctRow = ws.getRow(position + 1);
        ctRow.height = 56;

        ws.mergeCells(`A${position}:A${position + 3}`);
        let particulars = ws.getCell(`A${position + 3}`);
        particulars.value = "Particulars";
        particulars.font = this.fontStyle.header;
        particulars.border = this.borderStyle.full;
        particulars.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`B${position}:B${position + 3}`);
        let uacs_code = ws.getCell(`B${position + 3}`);
        uacs_code.value = "UACS Code";
        uacs_code.font = this.fontStyle.header;
        uacs_code.border = this.borderStyle.full;
        uacs_code.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`C${position}:K${position + 1}`);
        let approved_budget = ws.getCell(`C${position}`);
        approved_budget.value = `Approved Budget FY ${year + 1}`;
        approved_budget.font = this.fontStyle.header;
        approved_budget.border = this.borderStyle.full;
        approved_budget.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`L${position}:BD${position}`);
        let allotment = ws.getCell(`L${position}`);
        allotment.value = "Allotments";
        allotment.font = this.fontStyle.header;
        allotment.border = this.borderStyle.full;
        allotment.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`BE${position}:BS${position + 1}`);
        let utilizations = ws.getCell(`BE${position}`);
        utilizations.value = "Utilizations";
        utilizations.font = this.fontStyle.header;
        utilizations.border = this.borderStyle.full;
        utilizations.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`BT${position}:CH${position + 1}`);
        let disbursement = ws.getCell(`BT${position}`);
        disbursement.value = "Disbursement";
        disbursement.font = this.fontStyle.header;
        disbursement.border = this.borderStyle.full;
        disbursement.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`CI${position}:CT${position}`);
        let balances = ws.getCell(`CI${position}`);
        balances.value = "Balances";
        balances.font = this.fontStyle.header;
        balances.border = this.borderStyle.full;
        balances.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`L${position + 1}:Z${position + 1}`);
        let allotment_received = ws.getCell(`L${position + 1}`);
        allotment_received.value = "Allotment Received";
        allotment_received.font = this.fontStyle.header;
        allotment_received.border = this.borderStyle.full;
        allotment_received.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`AA${position + 1}:AO${position + 1}`);
        let adjustments = ws.getCell(`AA${position + 1}`);
        adjustments.value = "Adjustments (Reduction, Modification)";
        adjustments.font = this.fontStyle.header;
        adjustments.border = this.borderStyle.full;
        adjustments.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`AP${position + 1}:BD${position + 1}`);
        let adjusted_total = ws.getCell(`AP${position + 1}`);
        adjusted_total.value = "Adjusted Total Allotment";
        adjusted_total.font = this.fontStyle.header;
        adjusted_total.border = this.borderStyle.full;
        adjusted_total.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`CI${position + 1}:CK${position + 2}`);
        let unobligated = ws.getCell(`CI${position + 1}`);
        unobligated.value = "Unobligated Allotment";
        unobligated.font = this.fontStyle.header;
        unobligated.border = this.borderStyle.full;
        unobligated.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`CL${position + 1}:CQ${position + 1}`);
        let unpaid = ws.getCell(`CL${position + 1}`);
        unpaid.value = "Unpaid";
        unpaid.font = this.fontStyle.header;
        unpaid.border = this.borderStyle.full;
        unpaid.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`CR${position + 1}:CT${position + 2}`);
        let unreleased = ws.getCell(`CR${position + 1}`);
        unreleased.value = "Unreleased Approved Budget";
        unreleased.font = this.fontStyle.header;
        unreleased.border = this.borderStyle.full;
        unreleased.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`C${position + 2}:E${position + 2}`);
        let approved_budget_section = ws.getCell(`C${position + 2}`);
        approved_budget_section.value = "Approved Budget";
        approved_budget_section.font = this.fontStyle.header;
        approved_budget_section.border = this.borderStyle.full;
        approved_budget_section.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`F${position + 2}:H${position + 2}`);
        let adjustments_section = ws.getCell(`F${position + 2}`);
        adjustments_section.value = "Adjustments";
        adjustments_section.font = this.fontStyle.header;
        adjustments_section.border = this.borderStyle.full;
        adjustments_section.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`I${position + 2}:K${position + 2}`);
        let adjusted_approved = ws.getCell(`I${position + 2}`);
        adjusted_approved.value = "Adjusted Approved Budget";
        adjusted_approved.font = this.fontStyle.header;
        adjusted_approved.border = this.borderStyle.full;
        adjusted_approved.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`L${position + 2}:P${position + 2}`);
        let savings_prior = ws.getCell(`L${position + 2}`);
        savings_prior.value = `Savings from ${year} & Prior Years`;
        savings_prior.font = this.fontStyle.header;
        savings_prior.border = this.borderStyle.full;
        savings_prior.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`Q${position + 2}:U${position + 2}`);
        let continuing_investment = ws.getCell(`Q${position + 2}`);
        continuing_investment.value = "Continuing Investment";
        continuing_investment.font = this.fontStyle.header;
        continuing_investment.border = this.borderStyle.full;
        continuing_investment.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`V${position + 2}:Z${position + 2}`);
        let supplemental = ws.getCell(`V${position + 2}`);
        supplemental.value = `Supplemental Budget FY ${year + 1}`;
        supplemental.font = this.fontStyle.header;
        supplemental.border = this.borderStyle.full;
        supplemental.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`AA${position + 2}:AE${position + 2}`);
        let adj_savings_prior = ws.getCell(`AA${position + 2}`);
        adj_savings_prior.value = `Savings from ${year} & Prior Years`;
        adj_savings_prior.font = this.fontStyle.header;
        adj_savings_prior.border = this.borderStyle.full;
        adj_savings_prior.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`AF${position + 2}:AJ${position + 2}`);
        let adj_continuing = ws.getCell(`AF${position + 2}`);
        adj_continuing.value = "Continuing Investment";
        adj_continuing.font = this.fontStyle.header;
        adj_continuing.border = this.borderStyle.full;
        adj_continuing.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`AK${position + 2}:AO${position + 2}`);
        let adj_supplemental = ws.getCell(`AK${position + 2}`);
        adj_supplemental.value = `Supplemental Budget FY ${year + 1}`;
        adj_supplemental.font = this.fontStyle.header;
        adj_supplemental.border = this.borderStyle.full;
        adj_supplemental.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`AP${position + 2}:AT${position + 2}`);
        let total_savings_prior = ws.getCell(`AP${position + 2}`);
        total_savings_prior.value = `Savings from ${year} & Prior Years`;
        total_savings_prior.font = this.fontStyle.header;
        total_savings_prior.border = this.borderStyle.full;
        total_savings_prior.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`AU${position + 2}:AY${position + 2}`);
        let total_continuing = ws.getCell(`AU${position + 2}`);
        total_continuing.value = "Continuing Investment";
        total_continuing.font = this.fontStyle.header;
        total_continuing.border = this.borderStyle.full;
        total_continuing.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`AZ${position + 2}:BD${position + 2}`);
        let total_supplemental = ws.getCell(`AZ${position + 2}`);
        total_supplemental.value = `Supplemental Budget FY ${year + 1}`;
        total_supplemental.font = this.fontStyle.header;
        total_supplemental.border = this.borderStyle.full;
        total_supplemental.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`BE${position + 2}:BI${position + 2}`);
        let util_savings_prior = ws.getCell(`BE${position + 2}`);
        util_savings_prior.value = `Savings from ${year} & Prior Years`;
        util_savings_prior.font = this.fontStyle.header;
        util_savings_prior.border = this.borderStyle.full;
        util_savings_prior.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`BJ${position + 2}:BN${position + 2}`);
        let util_continuing = ws.getCell(`BJ${position + 2}`);
        util_continuing.value = "Continuing Investment";
        util_continuing.font = this.fontStyle.header;
        util_continuing.border = this.borderStyle.full;
        util_continuing.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`BO${position + 2}:BS${position + 2}`);
        let util_supplemental = ws.getCell(`BO${position + 2}`);
        util_supplemental.value = "Supplemental Budget";
        util_supplemental.font = this.fontStyle.header;
        util_supplemental.border = this.borderStyle.full;
        util_supplemental.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`BT${position + 2}:BX${position + 2}`);
        let disb_savings_prior = ws.getCell(`BT${position + 2}`);
        disb_savings_prior.value = `Savings from ${year} & Prior Years`;
        disb_savings_prior.font = this.fontStyle.header;
        disb_savings_prior.border = this.borderStyle.full;
        disb_savings_prior.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`BY${position + 2}:CC${position + 2}`);
        let disb_continuing = ws.getCell(`BY${position + 2}`);
        disb_continuing.value = "Continuing Investment";
        disb_continuing.font = this.fontStyle.header;
        disb_continuing.border = this.borderStyle.full;
        disb_continuing.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`CD${position + 2}:CH${position + 2}`);
        let disb_supplemental = ws.getCell(`CD${position + 2}`);
        disb_supplemental.value = "Supplemental Budget";
        disb_supplemental.font = this.fontStyle.header;
        disb_supplemental.border = this.borderStyle.full;
        disb_supplemental.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`CL${position + 2}:CN${position + 2}`);
        let due_demandable = ws.getCell(`CL${position + 2}`);
        due_demandable.value = "Due and Demandable";
        due_demandable.font = this.fontStyle.header;
        due_demandable.border = this.borderStyle.full;
        due_demandable.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`CO${position + 2}:CQ${position + 2}`);
        let not_yet_due = ws.getCell(`CO${position + 2}`);
        not_yet_due.value = "Not Yet Due & Demandable";
        not_yet_due.font = this.fontStyle.header;
        not_yet_due.border = this.borderStyle.full;
        not_yet_due.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        this.columns.filter((l: string) => l != 'A' && l != 'B').forEach((t: string, i: number) => {
            let ct = ws.getCell(`${t}${position + 3}`);
            ct.value = this.columnTitle[i];
            ct.font = this.fontStyle.header;
            ct.border = this.borderStyle.full;
            ct.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
        });


        // numbers in cell
        const cellNumberFormula = {
            5: "5=3+4",
            8: "8=6+7",
            9: "9=3+6",
            10: "10=4+7",
            11: "11=9+10",
            16: "16=12+13+14+15",
            21: "21=17+18+19+20",
            22: "22=12+17",
            23: "23=13+18",
            24: "24=14+19",
            25: "25=15+20",
            26: "26=22+23+24+25",
            31: "31=27+28+29+30",
            36: "36=32+33+34+35",
            37: "37=27+32",
            38: "38=28+33",
            39: "39=29+34",
            40: "40=30+35",
            41: "41=37+38+39+40",
            42: "42=12+27",
            43: "43=13+28",
            44: "44=14+29",
            45: "45=15+30",
            46: "46=42+43+44+45",
            51: "51=47+48+49+50",
            52: "52=42+47",
            53: "53=43+48",
            54: "54=44+49",
            55: "55=45+50",
            56: "56=52+53+54+55",
            61: "61=57+58+59+60",
            66: "66=62+63+64+65",
            67: "67=57+62",
            68: "68=58+63",
            69: "69=59+64",
            70: "70=60+65",
            71: "71=67+68+69+70",
            76: "76=72+73+74+75",
            81: "81=77+78+79+80",
            82: "82=72+77",
            83: "83=73+78",
            84: "84=74+79",
            85: "85=75+80",
            86: "86=82+83+84+85",
            87: "87=46-61",
            88: "88=51-66",
            89: "89=87+88",
            92: "92=90+91",
            93: "93=61-76-90",
            94: "94=66-81-91",
            95: "95=93+94",
            96: "96=9-16",
            97: "97=10-21",
            98: "98=90+91",
        };
        this.columns.forEach((l: string, i: number) => {
            let numCell = ws.getCell(`${l}${position + 4}`);
            let n = i + 1;
            numCell.value = (Object.keys(cellNumberFormula).includes(n.toString())) ? cellNumberFormula[n] : `${n}`;
            numCell.font = this.fontStyle.header;
            numCell.border = this.borderStyle.full;
            numCell.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
        });
    }

}
